<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.docCode"></hi-cell>
    <hi-cell title="采购组织：" :value="headInfo.purorgName || headInfo.purorgId"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="申请时间：" :value="headInfo.crtTime"></hi-cell>
    <hi-cell title="申请标题：" :value="headInfo.docTitle"></hi-cell>
    <hi-cell title="备注：" :value="headInfo.remark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'PriceLifespanChangeBaseInfo',
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
